import React from "react";

const OneTestimonial = ({ TestimonialIndex }) => {
  return <div></div>;
};

export default OneTestimonial;
